import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config';

export interface Niche {
    tag: string;
    count: number;
    freeSearch: boolean;
}

// Real niches present in the live database, fetched once and shared by
// every component that needs "which niches exist" — the sponsors-page
// filter chips (any niche with data), the homepage free-search picker and
// the footer's niche links (freeSearch niches only), and the niche landing
// pages. Nothing about the niche list is hardcoded on the frontend; a
// niche appears/qualifies for free search on its own as the database grows.
export const useNiches = () => {
    const [niches, setNiches] = useState<Niche[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        axios.get(`${config.backendUrl}sponsors/niches`).then((res) => {
            if (!mounted) return;
            setNiches(res.data?.niches || []);
        }).catch(() => {
            if (mounted) setNiches([]);
        }).finally(() => {
            if (mounted) setLoading(false);
        });
        return () => { mounted = false; };
    }, []);

    return { niches, loading };
};
